import script from "./MainAddCardDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./MainAddCardDialog.vue?vue&type=script&setup=true&lang=js"

import "./MainAddCardDialog.vue?vue&type=style&index=0&id=d96bf8a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d96bf8a0"]])

export default __exports__